import { render, staticRenderFns } from "./DashboardEtapas.vue?vue&type=template&id=0a430505"
import script from "./DashboardEtapas.vue?vue&type=script&lang=js"
export * from "./DashboardEtapas.vue?vue&type=script&lang=js"
import style0 from "./DashboardEtapas.vue?vue&type=style&index=0&id=0a430505&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports